import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { LazyLoadEvent, MenuItem, MessageService } from 'primeng/api';
import { RiderService, ConfigService, AppDataService } from 'app/services';
import { Utils } from 'app/utils';
import * as moment from 'moment';
import {
    LastActiveTypeModel, BackOfficeEnum, RiderVehicleTypeEnum,
    ServiceTypeEnum, MenuPermissionActionEnum, DriverCampaignType, FieldTypeEnum
} from 'app/models';
import { MenuHomeEnum } from 'app/components/home';
import { AppComponent } from 'app/app.component';
import {ColumnSelectorComponent} from 'app/column-selector/column-selector.component';
import { RiderTag } from 'app/models/rider/rider-tag.model';
import { TableLazyLoadEvent } from 'primeng/table';

@Component({
    selector: 'drivers-compaign',
    templateUrl: './drivers-compaign.component.html',
    styleUrls: ['./drivers-compaign.component.scss',
        '../../../../../styles/paginator.scss'],
    providers: [MessageService]
})
export class DriversCompaignComponent implements OnInit {
    public backOfficeActive!: BackOfficeEnum;
    public driverCampaignTypeEnum = DriverCampaignType;

    @Input()
    public menuPermissionActive!: string;

    @ViewChild(ColumnSelectorComponent)
    public columnSelector!: ColumnSelectorComponent;

    public loading: boolean = false;
    public fieldTypeEnum = FieldTypeEnum;
    public tableName: string = this.app.backOfficeRoot.getDriverType() + '-' +
        this.app.backOfficeRoot.getMenuValue();

    @Input()
    set _backOfficeActive(value: BackOfficeEnum) {
        if (this.backOfficeActive) {
            this.backOfficeActive = value;
            this.callBackOfficeForFilter(this.backOfficeActive);
            this.driverHeaderSearch = [];
            this.handleLazyLoad({
                first: 0,
                rows: this.rowsPerPage
            });
        } else {
            this.backOfficeActive = value;
            this.callBackOfficeForFilter(this.backOfficeActive);
        }
    }

    public menuHomeEnumActive!: MenuHomeEnum;
    @Input()
    set _menuHomeEnumActive(value: MenuHomeEnum) {
        this.menuHomeEnumActive = value;
    }

    public arrayFilterRiderTags = RiderTag.RiderTagList;
    public onlineStatuses = [
        { name: 'All', value: null },
        { name: 'Online', value: true },
        { name: 'Offline', value: false }
    ];
    public riders: Array<any> = [];
    public cols: any[] = [
        { field: 'RiderId', fieldType: FieldTypeEnum.InputNumber, model: 'riderId',
            placeholder: 'Type here', header: 'Driver ID', width: '20%', active: false },
        { field: 'UserName', fieldType: FieldTypeEnum.Inputs, model: 'userName',
            placeholder: 'Type here', header: 'Name', width: '20%', active: false },
        { field: 'Status', fieldType: FieldTypeEnum.Dropdown, options: this.onlineStatuses, model: 'isOnline',
            placeholder: 'Please Select', header: 'Status', width: '20%', active: false },

        { field: 'Phone', fieldType: FieldTypeEnum.InputNumber, model: 'phone',
            placeholder: 'Please Select', header: 'Mobile Number', width: '20%', active: false },
        { field: 'DriverTags', header: 'Driver Tag', width: '20%', fieldType: FieldTypeEnum.Dropdown, model: 'driverTags',
            options: this.arrayFilterRiderTags, placeholder: 'Select', active: false },

        { field: 'CountOffers', fieldType: FieldTypeEnum.InputNumber, model: 'countOffers',
            placeholder: 'Type here', header: 'No of Offered', width: '20%', active: false },
        { field: 'CountTrips', fieldType: FieldTypeEnum.InputNumber, model: 'countTrips',
            placeholder: 'Type here', header: 'No of Trips', width: '20%', active: false },
        { field: 'AcceptanceRate', fieldType: FieldTypeEnum.InputNumber, model: 'acceptanceRate',
            placeholder: 'Type here', header: 'Accep. Rate', width: '20%', active: false },
        { field: 'CancellationRate', fieldType: FieldTypeEnum.InputNumber, model: 'cancellationRate',
            placeholder: 'Type here', header: 'CXL Rate', width: '20%', active: false },
        { field: 'CompletionRate', fieldType: FieldTypeEnum.InputNumber, model: 'completionRate',
            placeholder: 'Type here', header: 'Comp. Rate', width: '20%', active: false },
        { field: 'FirstLogin', fieldType: FieldTypeEnum.Inputs, model: 'firstLogin',
            placeholder: 'Type here', header: 'First Login', width: '20%', active: false },
        { field: 'LastLogout', fieldType: FieldTypeEnum.Inputs, model: 'lastLogout',
            placeholder: 'Type here', header: 'Last Logout', width: '20%', active: false },
        { field: 'TotalActivity', fieldType: FieldTypeEnum.Inputs, model: 'totalActivity',
            placeholder: 'Type here', header: 'Total Activity', width: '20%', active: false },
        { field: 'TotalInactivity', fieldType: FieldTypeEnum.Inputs, model: 'totalInactivity',
            placeholder: 'Type here', header: 'Total Inactivity', width: '20%', active: false },
        // { field: 'Logins', fieldType: FieldTypeEnum.Inputs, model: 'logins',
        //     placeholder: 'Type here', header: 'Logins', width: '20%', active: false },
        // { field: 'Logouts', fieldType: FieldTypeEnum.Inputs, model: 'logouts',
        //     placeholder: 'Type here', header: 'Logouts', width: '20%', active: false },
        { field: 'EarningSum', fieldType: FieldTypeEnum.InputNumber, model: 'earningSum',
            placeholder: 'Type here', header: 'Earnings', width: '20%', active: false },
        { field: 'CommissionSum', fieldType: FieldTypeEnum.InputNumber, model: 'commissionSum',
            placeholder: 'Type here', header: 'Commission', width: '20%', active: false },
    ];
    public defaultCols = this.cols.map(x => x);

    // Grid settings
    public rowsPerPage: number = Utils.getRowsPerPageCount();
    public totalRecords: number = -1;

    public first: number = 0;
    public sortField: string | string[] = '';
    private sortOrder: number = 1;
    public skip: number = 0;
    public exportHeaderColumns: string[] = [];
    public exportDataColumns: string[] = [];

    public filter: {
        searchName: string;
    } = { searchName: '' };

    public driverHeaderSearch: any = {
        riderId: null,
        userName: null,
        phone: null,
        isOnline: null,
        countOffers: null,
        countTrips: null,
        acceptanceRate: null,
        cancellationRate: null,
        completionRate: null,
        firstLogin: null,
        lastLogout: null,
        totalActivity: null,
        totalInactivity: null,
        // logins: null,
        // logouts: null,
        earningSum: null,
        commissionSum: null,

        createdAt: null,
        onlineAt: null,
        lastActiveTypeObj: null,
        tripLocation: null
    };

    private searchTimer: number = 0;

    public selectedDriver: any;
    public visibleDetail: boolean = false;

    public driverVehicleTypes: any[] = [];
    public driverServiceTypes: any[] = [];
    public lastActiveTypeList = LastActiveTypeModel.LastActiveTypeList;
    public selectedDateRange: Date[] = [];

    public showDriversCompaignExportSidebar: boolean = false;
    public breadcrumbs: MenuItem[] = [{ icon: 'icon_back_office' }, { label: 'Application' }, { label: 'Drivers' },
        { label: this.app.backOfficeRoot.getDriverType() },{ label: this.app.backOfficeRoot.getMenuValue() }];

    constructor(
        private messageService: MessageService,
        private riderService: RiderService,
        public app: AppComponent,
        public appData: AppDataService,
        public configService: ConfigService) {
    }

    ngOnInit(): void {
        this.selectedDateRange[0] = new Date();
        this.selectedDateRange[1] = new Date();
    }

    public handleLazyLoad(event: TableLazyLoadEvent): void {
        this.skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortOrder = -1; // Desc
        }
        else {
            this.sortField = event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        this.tableName = this.app.backOfficeRoot.getDriverType() + '-' + this.app.backOfficeRoot.getMenuValue();
        this.loadColumnSelectorSettings();
        this.callBoardingTitles(this.skip);
        this.updateBreadcrumbs();
    }

    loadColumnSelectorSettings() {
        if (this.columnSelector) {
            this.columnSelector.loadTableSettings(this.app.backOfficeRoot.getDriverType() + '-' +
                this.app.backOfficeRoot.getMenuValue());
        }
    }

    onSelectedColumnsChange(event: any) {
        if (event && event.length > 0) {
            this.cols = event;
        } else {
            this.cols = this.defaultCols;
        }

        this.exportHeaderColumns = this.cols.map(x => x.header);
        this.exportDataColumns = this.cols.map(x => x.field);
    }

    updateBreadcrumbs() {
        if (this.appData.isBoracayLocation) {
            this.breadcrumbs = [{ icon: 'icon_back_office' }, { label: 'Application' }, { label: 'Drivers' },
                { label: this.app.backOfficeRoot.getMenuValue() },{ label: this.app.backOfficeRoot.getDriverType() }];
        } else {
            this.breadcrumbs = [{ icon: 'icon_back_office' }, { label: 'Application' }, { label: 'Drivers' },
                { label: this.app.backOfficeRoot.getDriverType() },{ label: this.app.backOfficeRoot.getMenuValue() }];
        }
    }

    public changeDateRange() {
        if (!this.selectedDateRange[1]) {
            return;
        }
        this.getCompaignRiders(0);
    }

    private callBoardingTitles(skip: number) {
        this.getCompaignRiders(skip);
    }

    getCompaignRiders(skip: number) {
        const dto = {
            StartDate: moment(this.selectedDateRange[0]).format('YYYY-MM-DD'),
            EndDate: moment(this.selectedDateRange[1]).format('YYYY-MM-DD'),
            SearchName: this.filter.searchName,
            RiderId: this.driverHeaderSearch.riderId,
            UserName: this.driverHeaderSearch.userName,
            Phone: (this.driverHeaderSearch.phone) ? this.driverHeaderSearch.phone+'' : '',
            IsOnline: this.driverHeaderSearch.isOnline,
            CountOffers: this.driverHeaderSearch.countOffers,
            CountTrips: this.driverHeaderSearch.countTrips,
            AcceptanceRate: (this.driverHeaderSearch.acceptanceRate) ? this.driverHeaderSearch.acceptanceRate : null,
            CancellationRate: (this.driverHeaderSearch.cancellationRate) ? this.driverHeaderSearch.cancellationRate : null,
            CompletionRate: (this.driverHeaderSearch.completionRate) ? this.driverHeaderSearch.completionRate : null,

            FirstLogin: (this.driverHeaderSearch.firstLogin) ? this.driverHeaderSearch.firstLogin : null,
            LastLogout: (this.driverHeaderSearch.lastLogout) ? this.driverHeaderSearch.lastLogout : null,
            TotalActivity: (this.driverHeaderSearch.totalActivity) ? this.driverHeaderSearch.totalActivity : null,
            TotalInactivity: (this.driverHeaderSearch.totalInactivity) ? this.driverHeaderSearch.totalInactivity : null,
            // Logins: (this.driverHeaderSearch.logins) ? this.driverHeaderSearch.logins : null,
            // Logouts: (this.driverHeaderSearch.logouts) ? this.driverHeaderSearch.logouts : null,

            EarningSum: this.driverHeaderSearch.earningSum,
            CommissionSum: this.driverHeaderSearch.commissionSum,

            CreatedAt: (this.driverHeaderSearch.createdAt) ? moment(this.driverHeaderSearch.createdAt).format('YYYY-MM-DDTHH:mm:ss') : null,
            OnlineAt: (this.driverHeaderSearch.onlineAt) ? moment(this.driverHeaderSearch.onlineAt).format('YYYY-MM-DDTHH:mm:ss') : null,
            LastActiveType: (this.driverHeaderSearch.lastActiveTypeObj) ? this.driverHeaderSearch.lastActiveTypeObj.value : null,
            LastActiveAt: (this.driverHeaderSearch.lastActiveTypeObj && this.driverHeaderSearch.lastActiveTypeObj.dateTime) ?
                moment(this.driverHeaderSearch.lastActiveTypeObj.dateTime).format('YYYY-MM-DDTHH:mm:ss') : null,
            ServiceTypes: this.driverServiceTypes,
            VehicleTypes: this.driverVehicleTypes,
            ClientLocationType: this.appData.getClientLocationType(),
            Skip: skip,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: this.sortOrder,
            TimeZoneOffset: Utils.getTimezoneOffset()
        };

        this.loading = true;
        this.riderService.getCompaignRiders(dto, this.messageService)
            .then(data => {
                this.loading = false;
                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.first = skip;
                this.totalRecords = data.TotalRecords;
                this.riders = data.Items;
                this.riders.forEach(item => {
                    item.StatusColor = '#fff';
                    item.StatusBgColor = (item.IsOnline) ? '#1CBA70' : '#ff0000';
                    item.AcceptanceRate = item.AcceptanceRate + '%';
                    item.CancellationRate = item.CancellationRate + '%';
                    item.CompletionRate = item.CompletionRate + '%';
                    item.EarningSum = '₱' + item.EarningSum;
                    item.CommissionSum = '₱' + item.CommissionSum;
                });
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public addOrRemoveRiderCampaign(riderObj: any) {
        if (this.appData.hasPermission(this.menuPermissionActive, MenuPermissionActionEnum.Create) ||
            this.appData.hasPermission(this.menuPermissionActive, MenuPermissionActionEnum.Delete)) {
            const dto = {
                RiderId: riderObj.RiderId,
                IsBelongCompany: false
            };
            this.riderService.addOrRemoveRiderCampaign(dto, this.messageService)
                .then(data => {
                    if (!data.Success) {
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                        return;
                    }
                    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Rider remove from campaign' });
                    this.getCompaignRiders(this.skip);
                });
        } else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Access denied' });
        }
    }

    public handleFilterChange(): void {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.getCompaignRiders(0);
            this.searchTimer = 0;
        }, 1500);
    }

    public handleShowDriverInfo(driver: any) {
        this.selectedDriver = driver;
        this.visibleDetail = true;
    }
    changedVisibleDetailEmit(value: any) {
        this.visibleDetail = value;
        this.getCompaignRiders(this.skip);
    }

    public handleShowDriversCompaignExportSidebar() {
        this.showDriversCompaignExportSidebar = true;
    }
    changedShowDriversCompaignExportSidebarEmit(value: any) {
        this.showDriversCompaignExportSidebar = value;
    }

    callBackOfficeForFilter(backOffice: BackOfficeEnum) {
        switch (backOffice) {
            case BackOfficeEnum.Passenger2W:
                this.driverVehicleTypes = [RiderVehicleTypeEnum.Moto];
                this.driverServiceTypes = [
                    ServiceTypeEnum.Ride,
                    ServiceTypeEnum.Hire,
                    ServiceTypeEnum.Transfer,
                    ServiceTypeEnum.ScanAndRide,
                    ServiceTypeEnum.Single,
                    ServiceTypeEnum.Charter];
                break;
            case BackOfficeEnum.Passenger3W:
                this.driverVehicleTypes = [RiderVehicleTypeEnum.ETrike];
                this.driverServiceTypes = [
                    ServiceTypeEnum.Ride,
                    ServiceTypeEnum.Hire,
                    ServiceTypeEnum.Transfer,
                    ServiceTypeEnum.ScanAndRide,
                    ServiceTypeEnum.Single,
                    ServiceTypeEnum.Charter];
                break;
            case BackOfficeEnum.Passenger4W:
                this.driverVehicleTypes = [
                    RiderVehicleTypeEnum.Sedan,
                    RiderVehicleTypeEnum.SUV,
                    RiderVehicleTypeEnum.Fastest,
                    RiderVehicleTypeEnum.PetTaxi,
                    RiderVehicleTypeEnum.Courier,
                    RiderVehicleTypeEnum.Cargo,
                    RiderVehicleTypeEnum.Van,
                    RiderVehicleTypeEnum.Minibus,
                    RiderVehicleTypeEnum.Multicab
                ];
                this.driverServiceTypes = [
                    ServiceTypeEnum.Ride,
                    ServiceTypeEnum.Hire,
                    ServiceTypeEnum.Transfer,
                    ServiceTypeEnum.ScanAndRide,
                    ServiceTypeEnum.Single,
                    ServiceTypeEnum.Charter];
                break;
            case BackOfficeEnum.Delivery2W:
                this.driverVehicleTypes = [RiderVehicleTypeEnum.Moto];
                this.driverServiceTypes = [
                    ServiceTypeEnum.Delivery,
                    ServiceTypeEnum.Food,
                    ServiceTypeEnum.Grocery];
                break;
            case BackOfficeEnum.Delivery4W:
                this.driverVehicleTypes = [RiderVehicleTypeEnum.Sedan,
                RiderVehicleTypeEnum.SUV,
                RiderVehicleTypeEnum.Fastest,
                RiderVehicleTypeEnum.PetTaxi,
                RiderVehicleTypeEnum.Courier,
                RiderVehicleTypeEnum.Cargo,
                RiderVehicleTypeEnum.Van,
                RiderVehicleTypeEnum.Minibus,
                RiderVehicleTypeEnum.Multicab];
                this.driverServiceTypes = [
                    ServiceTypeEnum.Delivery,
                    ServiceTypeEnum.Food,
                    ServiceTypeEnum.Grocery];
                break;
            default:
                this.driverVehicleTypes = [];
                this.driverServiceTypes = [];
                break;
        }
    }
}
